export default __webpack_public_path__ + "static/media/logomaia.ae792cd0.svg";